import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", path: "/" },
  { label: "影片分类", path: "/category" },
  { label: "专题合集", path: "/topic" },
  { label: "搜索影片", path: "/search" },
  { label: "关于我们", path: "/about" },
];

const genreLinks = [
  { label: "剧情", path: "/category?genre=剧情" },
  { label: "爱情", path: "/category?genre=爱情" },
  { label: "悬疑", path: "/category?genre=悬疑" },
  { label: "动作", path: "/category?genre=动作" },
  { label: "经典", path: "/category?genre=经典" },
  { label: "青春", path: "/category?genre=青春" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-background-100 border-t border-background-200 mt-auto">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-8 h-8 rounded-md bg-primary-600 text-background-50 flex items-center justify-center font-heading">
                一
              </span>
              <span className="font-heading text-base text-foreground-950">日本一级片</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 max-w-[280px]">
              专注日本影视作品资料整理与推荐，为影迷提供清晰的影片档案、分类索引与专题片单。
            </p>
            <p className="mt-4 text-xs text-foreground-500">
              本站为演示站点，所有影片资料与图片均为示例内容。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground-950 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-600 hover:text-primary-700 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground-950 mb-4">按类型浏览</h3>
            <ul className="space-y-2.5">
              {genreLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-600 hover:text-primary-700 transition-colors"
                  >
                    {link.label}影片
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground-950 mb-4">友情链接</h3>
            <ul className="space-y-2.5">
              <li className="text-sm text-foreground-500">日本电影资料馆（示例）</li>
              <li className="text-sm text-foreground-500">东京国际电影节（示例）</li>
              <li className="text-sm text-foreground-500">影评人协会专栏（示例）</li>
            </ul>
            <div className="mt-5 flex items-center gap-2">
              <span className="px-2 py-1 rounded-md bg-secondary-100 text-secondary-800 text-xs">资料演示</span>
              <span className="px-2 py-1 rounded-md bg-accent-100 text-accent-800 text-xs">前端样本数据</span>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 日本一级片 · 本站内容仅用于页面演示，不提供影片播放与下载服务。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <Link to="/about" className="hover:text-primary-700 transition-colors">
              版权说明
            </Link>
            <Link to="/about" className="hover:text-primary-700 transition-colors">
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}